import React from 'react'
import { Icon } from '@mobi/component-library/Legacy/Icon'
import * as iconPaths from '@mobi/component-library/Legacy/Icon/iconPaths'
import { appHistory } from '@core/Utils/routing/history'
import { FeaturedEventsItemStyled, FeaturedEventsItemTitleStyled } from './Item.styles'

interface FeaturedItemProps {
  text: string
  iconPathName: keyof typeof iconPaths
  url: string
  internalTrackingCode: string | null
  featureItemAction?: () => void
  className?: string
}

export const FeaturedItemListElement = ({
  text,
  iconPathName,
  url,
  internalTrackingCode,
  featureItemAction,
  className,
}: FeaturedItemProps) => {
  return (
    <FeaturedEventsItemStyled
      href={url}
      data-featureditem-internaltrackingcode={internalTrackingCode ?? ''}
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        featureItemAction?.()
        if (!url) return

        const isExternal = url.startsWith('https://') || url.includes(window.location.hostname)

        if (!isExternal) {
          e.preventDefault()
          appHistory.push(url)
        }
      }}
      className={className}
    >
      <Icon size='3rem' type={iconPathName} />
      <FeaturedEventsItemTitleStyled>{text}</FeaturedEventsItemTitleStyled>
    </FeaturedEventsItemStyled>
  )
}
